import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface VoucherParticipantState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allVoucherParticipantList: any[];
}

const initialState: VoucherParticipantState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allVoucherParticipantList: [],
};

export const voucherParticipantSlice = createSlice({
  name: 'voucherParticipant',
  initialState,
  reducers: {
    setVoucherParticipant: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherParticipantBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherParticipantList: (state, action) => {
      state.allVoucherParticipantList = action.payload.data; // no pagination
    },
    resetVoucherParticipant: () => initialState,
  },
});

export const { 
  setVoucherParticipant,
  setVoucherParticipantBySearch,
  setVoucherParticipantList,
  resetVoucherParticipant
} = voucherParticipantSlice.actions;

export const getVoucherParticipantDetails = (state: RootState) => state.voucherParticipant.data;
export const getVoucherParticipantBySearchDetails = (state: RootState) => state.voucherParticipant.data;
export const getVoucherParticipantTotalRecords = (state: RootState) => state.voucherParticipant.totalRecords;
export const getVoucherParticipantList = (state: RootState) => state.voucherParticipant.allVoucherParticipantList;

export default voucherParticipantSlice.reducer;
